export default __webpack_public_path__ + "static/media/orangeTheme-boy.0ebb8c72.svg";